import {isNumber} from "lodash-es"
import mapService from "@ui/services/MapService"
import {IFeature} from "./feature"
import {Point} from "./point"

export interface IFeaturesCollections {
  features: IFeature[]
}

export class FeaturesCollections implements IFeaturesCollections {
  features: IFeature[] = []

  constructor(points: IFeature[]) {
    this.features = points

    mapService.addMoveEndCallback( (event) => {
      const [width, height] = mapService.getMapSize() || []

      if (height && width) {
        const bottomleft = mapService.getCoordinateFromPixel([0, 0])
        const topleft = mapService.getCoordinateFromPixel([0, height])
        const bottomRight = mapService.getCoordinateFromPixel([width, 0])
        const topRight = mapService.getCoordinateFromPixel([width, height])
        const xs = [bottomleft[0], topleft[0], bottomRight[0], topRight[0]]
        const ys = [bottomleft[1], topleft[1], bottomRight[1], topRight[1]]
        this.features.forEach(feature => {
          const currentZoom = mapService.getZoom()
          if (currentZoom && feature.zoom.max < currentZoom && feature.zoom.min > currentZoom) {
            feature.check(Math.min(...xs), Math.max(...xs), Math.min(...ys), Math.max(...ys))
          }
        })
      }
    })

    mapService.addZoomChangedCallback(() => {
      this.features.forEach(feature => {
        const currentZoom = mapService.getZoom()
        feature.toggle(
          isNumber(currentZoom) && feature.zoom.max < currentZoom && feature.zoom.min > currentZoom,
          currentZoom)
      })
    })
  }
}

export {Point}
